import { render } from "./ProyectosN2Detalle.vue?vue&type=template&id=82754e04&ts=true"
import script from "./ProyectosN2Detalle.vue?vue&type=script&lang=ts"
export * from "./ProyectosN2Detalle.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__